var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.env === 'development')?_c('div',[_c('func-default-dev')],1):_vm._e(),(_vm.env !== 'development')?_c('div',[_c('func-default-prod')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }